import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18next from 'i18next'
import Panel from '../../UniformComponents/Panel'
import Select from '../form/Select'
import QuestionSelector from './QuestionSelector'

@observer
class DataSelector extends Component {
    render() {
        const { DataExplorerStore } = this.props
        const {
            industry,
            productType,
            surveyType,
            respondentType,
            loading,
            updateIndustry,
            updateProductType,
            updateSurveyType,
            updateRespondentType,
            collapseLeft,
            toggleCollapse,
        } = DataExplorerStore

        const industryLens = R.lensPath(['productMaps'])
        const productLens = R.lensPath(['productMaps', industry, 'children'])
        const surveyLens = R.lensPath(['productMaps', industry, 'children', productType, 'children'])
        const respondentLens = R.lensPath(
            ['productMaps', industry, 'children', productType, 'children', surveyType, 'children'],
        )

        if (loading) return <div />

        const industries = R.or(R.view(industryLens, DataExplorerStore), {})
        const products = R.or(R.view(productLens, DataExplorerStore), {})
        const surveys = R.or(R.view(surveyLens, DataExplorerStore), {})
        const respondents = R.or(R.view(respondentLens, DataExplorerStore), {})

        return (
            <Panel cssClass={`dataSelector ${collapseLeft ? 'collapsed' : ''}`}>
                <div className="collapseIcon">
                    <div className="iconContainer" onClick={toggleCollapse}>
                        {
                            collapseLeft
                                ? <i className="fa-regular fa-chevron-right" />
                                : <i className="fa-regular fa-chevron-left" />
                        }
                    </div>
                </div>
                <div className="collapsedMenuLabel" style={{ display: collapseLeft ? 'block' : 'none' }}>
                    {i18next.t('dataExplorer.hiddenMenuLabel')}
                </div>
                <div className="dataSelectorControls">
                    <h4>{i18next.t('dataExplorer.selectData')}</h4>
                    <div className="controlsPanel">
                        <Select
                            cssClass="formControl"
                            options={Object.values(industries)}
                            onBlur={updateIndustry}
                            value={Object.values(industries).find(({ value }) => value === industry)}
                            label="Industry"
                            name="industry"
                            blurOnClear
                            showDisabled={Object.values(industries).length < 2}
                        />
                        <Select
                            cssClass="formControl"
                            options={Object.values(products)}
                            onBlur={updateProductType}
                            value={Object.values(products)
                                .find(({ value }) => value === productType)}
                            label="Product Type"
                            name="productType"
                            blurOnClear
                            showDisabled={Object.values(products).length < 2}
                        />
                        <Select
                            cssClass="formControl"
                            options={Object.values(surveys)}
                            onBlur={updateSurveyType}
                            value={Object.values(surveys).find(({ value }) => value === surveyType)}
                            label="Survey Type"
                            name="surveyType"
                            blurOnClear
                            showDisabled={Object.values(surveys).length < 2}
                        />
                        <Select
                            cssClass="formControl"
                            options={Object.values(respondents)}
                            onBlur={updateRespondentType}
                            value={Object.values(respondents).find(({ value }) => value === respondentType) || ''}
                            label="Respondent Type"
                            name="respondentType"
                            blurOnClear
                            showDisabled={Object.values(respondents).length < 2}
                        />
                    </div>
                    <div className="questionRow">
                        <QuestionSelector DataExplorerStore={DataExplorerStore} />
                    </div>
                </div>
            </Panel>
        )
    }
}

export default DataSelector
